import React, { useState, useEffect } from 'react';
import Header from './Header';
import API_URL from '../config';
import logo from '../logo.svg';

function EmpresaUsuariosPage({ usuario, empresa, empresaSelecionada, onVoltar, onSair }) {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({
    id: null,
    usr_nome: '',
    usr_email: '',
    usr_login: '',
    senha: '',
    path_imagem: '',
    app_grupo_id: '',
    usr_carencia: 0,
    usr_validade: null,
  });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [pagina, setPagina] = useState(1);
  const [uploading, setUploading] = useState(false);
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });
  const [grupos, setGrupos] = useState([]);

  const PAGE_SIZE = 12;

  useEffect(() => {
    fetchUsuarios();
    fetchGrupos();
    // eslint-disable-next-line
  }, [empresaSelecionada.id]);

  const fetchUsuarios = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/empresas_usuarios?empresa_id=${empresaSelecionada.id}`);
      const data = await res.json();
      setUsuarios(Array.isArray(data) ? data : []);
    } catch {
      setUsuarios([]);
      setErro('Erro ao buscar usuários');
    }
    setLoading(false);
  };

  const fetchGrupos = async () => {
    try {
      const res = await fetch(`${API_URL}/app_grupos?empresa_id=${empresaSelecionada.id}`);
      const data = await res.json();
      setGrupos(Array.isArray(data) ? data : []);
    } catch {
      setGrupos([]);
    }
  };

  const getImagemUrl = (path) => {
    if (!path) return logo;
    if (path.startsWith('https://')) return path;
    return `https://conexaopix.com.br/docs${path}`;
  };

  const abrirModal = (usuario = null) => {
    if (usuario) {
      let path_imagem = usuario.path_imagem || '';
      if (path_imagem && !path_imagem.startsWith('https://')) {
        path_imagem = `https://conexaopix.com.br/docs${path_imagem}`;
      }
      setForm({
        id: usuario.id,
        usr_nome: usuario.usr_nome || '',
        usr_email: usuario.usr_email || '',
        usr_login: usuario.usr_login || '',
        senha: '',
        path_imagem,
        app_grupo_id: usuario.app_grupo_id || '',
        usr_carencia: usuario.usr_carencia !== null && usuario.usr_carencia !== undefined ? usuario.usr_carencia : 0,
        usr_validade: usuario.usr_validade || null,
      });
      setEditando(true);
    } else {
      setForm({
        id: null,
        usr_nome: '',
        usr_email: '',
        usr_login: '',
        senha: '',
        path_imagem: '',
        app_grupo_id: '',
        usr_carencia: 0,
        usr_validade: null,
      });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({
      id: null,
      usr_nome: '',
      usr_email: '',
      usr_login: '',
      senha: '',
      path_imagem: '',
      app_grupo_id: '',
      usr_carencia: 0,
      usr_validade: null,
    });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(f => ({ ...f, [name]: checked }));
    } else if (name === 'usr_nome' || name === 'usr_email') {
      setForm(f => ({ ...f, [name]: value.toUpperCase() }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setErro('');
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('empresa_id', empresaSelecionada.id);
    try {
      const res = await fetch(`${API_URL}/upload-usuario-imagem`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Erro ao fazer upload');
      const data = await res.json();
      if (data.path) {
        const urlCompleta = "https://conexaopix.com.br/docs" + data.path;
        setForm(f => ({ ...f, path_imagem: urlCompleta }));
      } else {
        setErro('Erro ao fazer upload da imagem (resposta inválida do servidor)');
        setForm(f => ({ ...f, path_imagem: '' }));
      }
    } catch (err) {
      setErro('Erro ao fazer upload da imagem');
      setForm(f => ({ ...f, path_imagem: '' }));
    }
    setUploading(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (uploading) {
      setErro('Aguarde o upload da imagem!');
      return;
    }
    if (!form.usr_nome || !form.usr_email || (!editando && !form.senha) || !form.app_grupo_id) {
      setErro('Preencha todos os campos obrigatórios!');
      return;
    }
    try {
      const dados = {
        usr_nome: form.usr_nome,
        usr_email: form.usr_email,
        usr_login: editando ? form.usr_login : form.usr_email.split('@')[0].substring(0, 20),
        app_grupo_id: form.app_grupo_id,
        path_imagem: form.path_imagem || null,
        usr_administrador: 'N',
        usr_tipo_expiracao: 'N',
        usr_carencia: form.usr_carencia,
        usr_validade: form.usr_validade,
        ativo: true,
        funcionario: 'E',
        usr_senha_mobile: form.senha
      };
      if (!editando || form.senha) {
        dados.senha = form.senha;
      }
      let res;
      if (editando && form.id) {
        res = await fetch(`${API_URL}/empresas_usuarios/${form.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dados),
        });
      } else {
        res = await fetch(`${API_URL}/empresas_usuarios`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...dados, senha: form.senha, empresa_id: empresaSelecionada.id }),
        });
      }
      if (!res.ok) throw new Error('Erro ao salvar usuário');
      fecharModal();
      fetchUsuarios();
    } catch (err) {
      setErro(err.message || 'Erro ao salvar usuário');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/empresas_usuarios/${confirmarExclusao.id}/desativar`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
      });
      fetchUsuarios();
    } catch {
      setErro('Erro ao desativar usuário');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const usuariosFiltrados = usuarios.filter(u =>
    (u.usr_nome || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    (u.usr_email || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    String(u.usuario_id).includes(pesquisa)
  );
  // Ordenar: ativos primeiro, inativos por último, e dentro de cada grupo por nome
  const usuariosOrdenados = usuariosFiltrados.slice().sort((a, b) => {
    // Ativos primeiro
    if ((a.ativo === false) && (b.ativo !== false)) return 1;
    if ((a.ativo !== false) && (b.ativo === false)) return -1;
    // Ordem alfabética nome
    return (a.usr_nome || '').localeCompare(b.usr_nome || '', 'pt', { sensitivity: 'base' });
  });
  const totalPaginas = Math.ceil(usuariosOrdenados.length / PAGE_SIZE);
  const usuariosPaginados = usuariosOrdenados.slice((pagina - 1) * PAGE_SIZE, pagina * PAGE_SIZE);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Usuários</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por nome ou email..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {usuariosPaginados.map(u => (
                <div key={u.usuario_id} className={`bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200 ${u.ativo === false ? 'opacity-50 grayscale' : ''}`}>
                  {u.path_imagem ? (
                    <img src={getImagemUrl(u.path_imagem)} alt={u.usr_nome} className="w-16 h-16 object-cover rounded mx-auto mb-2 border shadow" />
                  ) : (
                    <img src={logo} alt="Logo" className="w-16 h-16 object-cover rounded mx-auto mb-2 border shadow" />
                  )}
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold text-blue-800 text-lg">{u.usr_nome}</span>
                    <div className="flex space-x-2">
                      <button onClick={() => abrirModal(u)} title="Editar" className="text-blue-600 hover:text-blue-900">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                      </button>
                      <button onClick={() => handleDelete(u.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                      </button>
                    </div>
                  </div>
                  <div className="text-gray-700 mb-1"><b>ID:</b> {u.usuario_id}</div>
                  <div className="text-gray-700 mb-1"><b>Email:</b> {u.usr_email}</div>
                  <div className="text-gray-700 mb-1"><b>Status:</b> {u.ativo ? 'Ativo' : 'Inativo'}</div>
                  <div className="text-gray-700 mb-1"><b>Licenças:</b> {u.licencas}</div>
                </div>
              ))}
              {usuariosPaginados.length === 0 && (
                <div className="col-span-full text-center py-8 text-gray-500">Nenhum usuário encontrado.</div>
              )}
            </div>
            {totalPaginas > 1 && (
              <div className="flex justify-center items-center mt-8 mb-2 w-full">
                {(() => {
                  const pages = [];
                  let start = Math.max(1, pagina - 3);
                  let end = Math.min(totalPaginas, pagina + 3);
                  if (pagina <= 4) {
                    start = 1;
                    end = Math.min(7, totalPaginas);
                  } else if (pagina > totalPaginas - 4) {
                    start = Math.max(1, totalPaginas - 6);
                    end = totalPaginas;
                  }
                  if (start > 1) pages.push(<span key="start-ellipsis" className="px-2">...</span>);
                  for (let i = start; i <= end; i++) {
                    pages.push(
                      <button
                        key={i}
                        className={`w-10 h-10 flex items-center justify-center rounded transition font-semibold border mx-0.5
                          ${pagina === i ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'}`}
                        onClick={() => setPagina(i)}
                      >
                        {i}
                      </button>
                    );
                  }
                  if (end < totalPaginas) pages.push(<span key="end-ellipsis" className="px-2">...</span>);
                  return pages;
                })()}
              </div>
            )}
          </>
        )}

        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Usuário"
        >
          +
        </button>

        {/* Modal de formulário */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl relative max-h-[90vh] overflow-y-auto">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Usuário' : 'Novo Usuário'}</h3>
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Card 1: Dados principais */}
                <div className="bg-blue-50 rounded-lg shadow p-4 border border-blue-200 mb-4">
                  <h4 className="font-bold text-blue-700 mb-3">Dados do Usuário</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nome*</label>
                      <input name="usr_nome" value={form.usr_nome} onChange={handleChange} className="border rounded px-3 py-2 w-full" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email*</label>
                      <input name="usr_email" value={form.usr_email} onChange={handleChange} className="border rounded px-3 py-2 w-full" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Senha*</label>
                      <input name="senha" type="password" value={form.senha} onChange={handleChange} className="border rounded px-3 py-2 w-full" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Permissão*</label>
                      <select name="app_grupo_id" value={form.app_grupo_id} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                        <option value="">Selecione...</option>
                        {grupos.map(g => <option key={g.id} value={g.id}>{g.grupo}</option>)}
                      </select>
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Imagem (upload)</label>
                      <input type="file" accept="image/*" onChange={handleFileChange} className="border rounded px-3 py-2 w-full" />
                      {form.path_imagem && (
                        <div className="mt-2 flex items-center">
                          <img src={getImagemUrl(form.path_imagem)} alt="Preview" className="w-16 h-16 object-cover rounded shadow border" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {erro && <div className="text-red-600 font-bold mb-2 text-center">{erro}</div>}
                <div className="flex justify-end space-x-2 mt-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" disabled={uploading} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{uploading ? 'Enviando imagem...' : editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <h3 className="text-xl font-bold text-blue-700 mb-4">Confirmar Desativação</h3>
              <p>Tem certeza que deseja desativar este usuário?<br/>Ele não será excluído, apenas ficará inativo no sistema.</p>
              <div className="flex justify-end space-x-2 mt-6">
                <button onClick={cancelarRemocao} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button onClick={confirmarRemocao} className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition">Desativar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmpresaUsuariosPage; 